var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 763,
    viewBox: "0 0 1600 763",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M730.657 1L-248 561",
    stroke: "#001E88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M788.226 33.9409L-190.432 593.941",
    stroke: "#001E88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M845.794 66.8818L-132.863 626.882",
    stroke: "#001E88"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M903.362 99.8237L-75.2956 659.824",
    stroke: "#001E88"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M960.498 132.707L-18.1596 692.707",
    stroke: "#001E88"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1018.5 165.707L39.8404 725.707",
    stroke: "#001E88"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1076.07 198.647L97.4083 758.647",
    stroke: "#001E88"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1133.63 231.588L154.977 791.588",
    stroke: "#001E88"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1191.2 264.529L212.545 824.529",
    stroke: "#001E88"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1248.77 297.471L270.113 857.471",
    stroke: "#001E88"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1306.34 330.412L327.681 890.412",
    stroke: "#001E88"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1363.91 363.354L385.249 923.354",
    stroke: "#001E88"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1421.47 396.293L442.817 956.293",
    stroke: "#001E88"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1479.04 429.235L500.386 989.235",
    stroke: "#001E88"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1536.61 462.176L557.953 1022.18",
    stroke: "#001E88"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1594.18 495.118L615.522 1055.12",
    stroke: "#001E88"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1651.75 528.059L673.089 1088.06",
    stroke: "#001E88"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1709.31 561L730.657 1121",
    stroke: "#001E88"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M615.521 66.8818L1594.18 626.882",
    stroke: "#001E88"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M557.953 99.8237L1536.61 659.824",
    stroke: "#001E88"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M500.385 132.765L1479.04 692.765",
    stroke: "#001E88"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M442.817 165.707L1421.47 725.707",
    stroke: "#001E88"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M385.249 198.647L1363.91 758.647",
    stroke: "#001E88"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M327.681 231.588L1306.34 791.588",
    stroke: "#001E88"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M270.113 264.529L1248.77 824.529",
    stroke: "#001E88"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M212.556 297.471L1191.21 857.471",
    stroke: "#001E88"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M154.988 330.412L1133.65 890.412",
    stroke: "#001E88"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M97.42 363.354L1076.08 923.354",
    stroke: "#001E88"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M39.8521 396.293L1018.51 956.293",
    stroke: "#001E88"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M-17.7161 429.235L960.942 989.235",
    stroke: "#001E88"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M-75.2841 462.176L903.374 1022.18",
    stroke: "#001E88"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M-132.852 495.118L845.806 1055.12",
    stroke: "#001E88"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceback);
export default __webpack_public_path__ + "static/media/serviceback.63a3ff69d08141f920ecf93cff4aa32c.svg";
export { ForwardRef as ReactComponent };